import TopBar from './components/TopBar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ValuesSection from './components/ValuesSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main>
      <TopBar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ValuesSection />
      <ContactFooter />
    </main>
  );
}